import { WebUrl } from "shared-web/lib/webUrl"

export function pricingTier(pricingTierId: string): WebUrl {
  return {
    pathname: `/admin/customer/pricing-tier/${pricingTierId}`,
  }
}
